
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startListadoOrdenesCompra, startOrdenCompraXID } from "../../../services";






export const useOrdenCompraXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ordencompra-id', id], 
        queryFn: () => startOrdenCompraXID(id),
    });

    return { data, isLoading }
}





export const useOrdenesCompraQuery = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['ordenes-compra', { page, termino }], 
        queryFn: () => startListadoOrdenesCompra({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}
